import { FormBase } from "../../../../util/form-base-form";

class XEmbedForm extends FormBase {
    public getEmbedScript(root: ParentNode = document): HTMLScriptElement | null {
        return this.queryElement(root, 'script[data-role="x-embed-widgets"]', HTMLScriptElement);
    }
}

export const xEmbedForm = new XEmbedForm();
